import { combineReducers } from "redux";
import applicationReducer from "application/redux/applicationReducer";
import authReducer from "auth/authReducer";
import { mediaViewerReducer } from "media-viewer/mediaViewerRedux";

export default function (routerReducer) {
  return combineReducers({
    application: applicationReducer,
    auth: authReducer,
    router: routerReducer,
    mediaViewer: mediaViewerReducer,
  });
}
